import { TreeSelect } from 'antd';
import { Text } from '.';
import styled from '@emotion/styled';

const TitleNode = styled.span`
  ${({ background }) => background && `background: ${background};`}
  ${({ color }) => color && `color: ${color};`}
  &:hover {
    ${({ hoverBackground }) =>
      hoverBackground && `background: ${hoverBackground};`}
  }
`;

export const TreeSelectDropdown = ({
  name,
  label,
  disabled,
  placeholder,
  options,
  value,
  onChange,
  className,
  popupClassName,
  suffixIcon,
}) => {
  const renderTreeNodes = (data, parentKey = '') =>
    data.map((item, index) => {
      const nodeKey =
        item.value !== null && item.value !== undefined
          ? String(item.value)
          : `${parentKey}_${index}_null`;

      const className = `p-2 ${item.className}`;

      const props = {
        value: item.value,
        title: (
          <TitleNode
            className={className}
            background={item.style?.background}
            color={item.style?.color}
            hoverBackground={item.style?.hoverBackground}
          >
            {item.title}
          </TitleNode>
        ),
      };

      if (item.children) {
        props.children = renderTreeNodes(item.children, nodeKey);
        props.disabled = item.value;
      }

      return <TreeSelect.TreeNode key={nodeKey} {...props} />;
    });

  return (
    <div className="w-full custom-select-component">
      {label && (
        <Text type={'label'} htmlFor={name}>
          {label}
        </Text>
      )}
      <TreeSelect
        id={name}
        bordered={false}
        suffixIcon={suffixIcon}
        showSearch={false}
        disabled={disabled}
        style={{ width: '100%' }}
        placeholder={placeholder}
        className={className || 'single-select'}
        popupClassName={popupClassName || 'single-select__dropdown'}
        treeDefaultExpandAll={false}
        dropdownStyle={{
          minWidth: 'fit-content',
          zIndex: 999999999,
          padding: '10px 9px 4px 4px',
        }}
        value={value}
        onChange={onChange}
        listHeight={300}
      >
        {renderTreeNodes(options)}
      </TreeSelect>
    </div>
  );
};
